<div class="modalSuccess">
    <div class="headerModal">
      <h4 class="titleModal">Vuoi dissociare <span>{{name}} </span> <span>{{surname}}</span> dalla filiale ?</h4>
    </div>
    <div class="btnModal">
        <button class="annulla" (click)="close()">NO</button>
      <button class="conferma" (click)="save()">SI</button>
    </div>
</div>